import { useMutation } from "react-query";
import { sendToEmail } from "../api-services/email";

const useSendEmail = (mutationOptions = {}) => {
	const mutation = useMutation({
		mutationFn: (payload) => sendToEmail(payload),
		onSuccess: (data) => {
			if (mutationOptions.onSuccess) {
				mutationOptions.onSuccess(data);
			}
		},
		onError: (error) => {
			if (mutationOptions.onError) {
				mutationOptions.onError(error);
			}
		},
	});

	return {
		sendEmail: mutation.mutate,
		isLoading: mutation.isPending,
		...mutation,
	};
};

export { useSendEmail };